import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,Modal,ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../components/Common/withRouter";
import { gethotelinfoIdAPI } from "../../helpers/api.ts";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";

import { createSelector } from "reselect";

const UserProfile = () => {
  document.title = "Profile |  - Admin & Dashboard Template";

  const dispatch = useDispatch();

  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [hotelInfo, setHotelInfo] = useState(null);

  // Hotel owners see their hotel's details (status, approval and expiry) here too.
  useEffect(() => {
    const stored = (() => {
      try { return JSON.parse(localStorage.getItem("user") || "{}"); } catch (e) { return {}; }
    })();
    if (stored?.role !== "HOTEL_ADMIN" || !stored?.hotel_id) return;
    gethotelinfoIdAPI(stored.hotel_id)
      .then((res) => { if (res?.success) setHotelInfo(res.data); })
      .catch(() => {});
  }, []);

  const toggleModal = () => setShowModal(!showModal);

  const handleDelete = () => {
    // Here you would trigger the delete API call or action
    alert("Your account deletion process has started!");
    setShowModal(false);
  };


  const userprofilepage = createSelector(
    (state) => state.profile,
    (state) => ({
      error: state.error,
      success: state.success,
    })
  );
  // Inside your component
  const { error, success } = useSelector(userprofilepage);

  useEffect(() => {
    if (localStorage.getItem("user")) {
      const obj = JSON.parse(localStorage.getItem("user"));
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setname(obj.displayName);
        setemail(obj.email);
        setidx(obj.uid);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setname(obj.username);
        setemail(obj.email);
        setidx(obj.uid);
      }
      setTimeout(() => {
        dispatch(resetProfileFlag());
      }, 3000);
    }
  }, [dispatch, success]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: name || "",
      idx: idx || "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Home" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {error && error ? (
                <Alert color="danger">
                  <div>{error}</div>
                </Alert>
              ) : null}
              {success ? (
                <Alert color="success">
                  <div>{success}</div>
                </Alert>
              ) : null}

              <Card>
                <CardBody>
                  <div className="d-flex align-items-center gap-2">
                    <div className="ms-3">
                    <img
            className="rounded-circle header-profile-user me-2"
            src={"https://imgs.search.brave.com/JAHeWxUYEwHB7KV6V1IbI9oL7wxJwIQ4Sbp8dHQL09A/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9tZWRp/YS5nZXR0eWltYWdl/cy5jb20vaWQvMjAx/MzkxNTc2NC9waG90/by91c2VyLWljb24t/aW4tZmxhdC1zdHls/ZS5qcGc_cz02MTJ4/NjEyJnc9MCZrPTIw/JmM9UEotMnZvUWZh/Q3hhZUNsdzZYYlVz/QkNaT3NTTjlIVWVC/SUg1Qk82VmRScz0"}
            alt="Header Avatar"
          />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-0">{email}</p>
                        {/* <p className="mb-0">Id no: #{idx}</p> */}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {hotelInfo && (
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <h5 className="mb-3">Hotel Details</h5>
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <div className="text-muted small">HOTEL</div>
                        <div className="fw-semibold">{hotelInfo.hotel_name || "-"}</div>
                        <div className="text-muted">{hotelInfo.address || ""}</div>
                        <div className="mt-1">Total rooms: <strong>{hotelInfo.total_rooms ?? "-"}</strong></div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="text-muted small">OWNER</div>
                        <div className="fw-semibold">{hotelInfo.owner?.name || hotelInfo.owner_name || "-"}</div>
                        <div className="text-muted">{hotelInfo.owner?.email || hotelInfo.owner_email || ""}</div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="text-muted small">STATUS</div>
                        <div className="fw-semibold">{hotelInfo.status || "-"}</div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="text-muted small">APPROVAL</div>
                        <div>
                          Approved on{" "}
                          <strong>
                            {hotelInfo.approval_date ? new Date(hotelInfo.approval_date).toLocaleDateString("en-GB") : "not approved yet"}
                          </strong>
                        </div>
                        {hotelInfo.days_remaining !== null && hotelInfo.days_remaining !== undefined && (
                          <div>
                            Days remaining:{" "}
                            <strong
                              style={{
                                color: hotelInfo.days_remaining <= 30 ? "#c0363f" : hotelInfo.days_remaining <= 90 ? "#d98a00" : "#2f8f4f",
                              }}
                            >
                              {hotelInfo.days_remaining} days
                            </strong>
                            {hotelInfo.expires_on && (
                              <span className="text-muted"> (expires {new Date(hotelInfo.expires_on).toLocaleDateString("en-GB")})</span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          <Modal isOpen={showModal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Confirm Account Deletion</ModalHeader>
        <ModalBody style={{ backgroundColor: "#ffe5e5", color: "#800000" }}>
          <p>
            <strong>Warning:</strong> This account will be permanently deleted
            within <b>7 business days</b>.
          </p>
          <p>
            All your personal data will be completely removed from our system.
            This action cannot be undone.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          <Button color="danger" onClick={handleDelete}>
            Confirm Delete
          </Button>
        </ModalFooter>
      </Modal>

          <Button type="submit" color="danger" onClick={toggleModal}>
        Delete my Account
      </Button>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
